import { TranslationKey } from './../../../../../types/translation/TranslationKey';

import { Grid } from '@mui/material';
import React, { useState } from 'react';
import Modal from '../../Modal/Modal';
import FileViewLoader from '../FileViewLoader';
import ModalPane from '../../Modal/components/ModalPane';
import WarningIcon from '@mui/icons-material/Warning';
import { testIds } from '../../../../../util/identifiers/identifiers.util';
import { t } from '../../../../../types/translation/Translator';
import { FileEntityType, FilePreview } from '../../../../../types/file';

interface ImagePickerModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  fileSasIdsOrPreviews: (string | FilePreview)[];
  onSelected: (selected: string) => void;
  fileEntityType: FileEntityType;
}

export default function ImagePickerModal({
  open,
  setOpen,
  fileSasIdsOrPreviews,
  onSelected,
  fileEntityType,
}: ImagePickerModalProps) {
  const [selected, setSelected] = useState('');

  const handleConfirm = () => {
    onSelected(selected);
    setOpen(false);
    setSelected('');
  };

  const style = (id: string) => {
    if (id === selected) {
      return {
        border: '1px solid blue',
      };
    }
  };

  return (
    <Modal
      title={'Select an Image'}
      onClose={() => setOpen(false)}
      open={open}
      width='1000px'
      height='calc(90vh - 100px)'
    >
      {!fileSasIdsOrPreviews.length ? (
        <div className='flex h-full w-full flex-col items-center justify-center' data-testid={testIds.noItemsFound}>
          <WarningIcon sx={{ fontSize: '50px' }} className='text-gray-300' />
          <p className='select-none text-xl font-semibold text-gray-300'>
            {t(TranslationKey.noItemsFound).singular.label}
          </p>
        </div>
      ) : (
        <ModalPane
          footerButtons={[
            { text: t(TranslationKey.select).singular.label, onClick: handleConfirm, style: 'secondary' },
          ]}
          overflow='auto'
        >
          <Grid container spacing={1}>
            {fileSasIdsOrPreviews.map((file, i) =>
              typeof file === 'string' ? (
                <Grid
                  key={file}
                  item
                  xs={6}
                  onClick={() => setSelected(file)}
                  height={'200px'}
                  width={'300px'}
                  display='flex'
                  alignItems={'center'}
                  justifyContent={'center'}
                  style={style(file)}
                  className='cursor-pointer'
                >
                  <FileViewLoader fileEntityType={fileEntityType} className={'p-2'} fileId={file} />
                </Grid>
              ) : (
                <Grid
                  key={`${file.name}-${i}`}
                  item
                  xs={6}
                  onClick={() => setSelected(file.id)}
                  height={'200px'}
                  width={'300px'}
                  display='flex'
                  alignItems={'center'}
                  justifyContent={'center'}
                  style={style(file.id)}
                  className='cursor-pointer'
                >
                  <img className={'p-2'} src={file.data} />
                </Grid>
              ),
            )}
          </Grid>
        </ModalPane>
      )}
    </Modal>
  );
}
